// @vue/component
export default {
  props: {
    field: {
      type: Object,
      required: true,
    },
    required: {
      type: Boolean,
      default: false,
    },
    value: {
      type: undefined,
      default: undefined,
    },
  },
  data() {
    return {
      answer: this.value,
    };
  },
  computed: {
    allowedResponses() {
      return _.get(this.field, 'allowed_responses', [])
        .map(response => _.get(response, 'response.text', ''));
    },
    inputLabel() {
      const flavourBasedLabels = {
        currency: 'Please enter a number',
        multiselect: 'Please select one or more options',
        number: 'Please enter a number',
        percentage: 'Please enter a number',
        select: 'Please select an option',
        text: 'Please enter a value',
        textarea: 'Please enter some text',
      };
      return this.field.secondary_text || flavourBasedLabels[this.field.flavour] || '';
    },
    renderSelectAsRadioButtons() {
      return this.allowedResponses && this.allowedResponses.length <= 3;
    },
    validationRules() {
      return _.get(this.field, 'required') || this.required ? 'required' : '';
    },
  },
  watch: {
    answer(answer) {
      this.$emit('input', answer);
    },
    value(value) {
      this.answer = value;
    },
  },
  methods: {
    getErrorMessages(invalid) {
      const defaultErrorMessage = 'A response is required for this question.';
      return invalid ? defaultErrorMessage : '';
    },
  },
};
